<div class="onboarding-form">
  @if (loading()) {
    <app-loader
      class="my-4"
      loadingText="Loading..."></app-loader>
  } @else {
    @if (valid()) {
      @if (success()) {
        <h1>Success</h1>
        <p class="text-muted fw-semibold">Thank you for taking the time to complete the required authorisation.</p>
        <div class="mt-5">
          <a
            class="btn btn-primary btn-lg px-5"
            href="{{ websiteBaseUrl }}">
            Close
            <i class="ms-2 iconoir-arrow-right"></i>
          </a>
        </div>
      } @else {
        <h1>Directors authorisation</h1>
        <app-pays-checkbox
          [(control)]="chkBoxValue"
          [label]="chkBoxLabel()"
          [id]="'director_auth_checkbox'"></app-pays-checkbox>
        <div class="mt-5">
          <button
            id="signupDirectorApproval"
            class="btn btn-primary btn-lg"
            [disabled]="disabledBtn()"
            (click)="onSubmit()">
            Continue
            <i class="ms-2 iconoir-arrow-right"></i>
          </button>
        </div>
      }
    } @else {
      @if (alreadyApproved()) {
        <h1>Authorisation Complete</h1>
        <p class="text-muted fw-semibold">
          We’ve already received the necessary authorisations for your business, so no further action is required.<br />
          <br />
          Your company is now ready to use Paystashio.
        </p>
        <div class="mt-5">
          <a
            class="btn btn-primary btn-lg px-5"
            href="{{ websiteBaseUrl }}">
            Close
            <i class="ms-2 iconoir-arrow-right"></i>
          </a>
        </div>
      } @else {
        <h1>Oh no...</h1>
        We encountered a problem while trying to validate your request. Please reach out to your company representative
        registering for Paystashio. They will be able to send a new verification link to your phone number.
      }
    }
  }
</div>
